import React, { useState, useEffect } from 'react';
import './WelcomeSection.css';

const WelcomeSection = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const stats = [
    {
      number: '10K+',
      label: 'Decoration Done',
      color: '#BDDDE4',
      lightBg: true
    },
    {
      number: 'Pro',
      label: 'Team',
      color: '#9EC6F3'
    },
    {
      number: '5K+',
      label: 'Satisfied customers',
      color: '#9FB3DF'
    },
  ];

  return (
    <section id="about" className="welcome-section">
      <div className="welcome-container">
        <div className="welcome-image-container">
          <img 
            src="/images/banners/freepik__the-style-is-can-image-photography-with-natural__24137.webp" 
            alt="Bubbles & Balloons Setup"
            className="welcome-image"
          />
        </div>
        
        <div className="welcome-content">
          <h2 className="welcome-content-title">
            Welcome to <span className="highlight-text">Bubbles & Balloons</span>
          </h2>
          
          <p className="welcome-description">
            At Bubbles & Balloons, we believe that every celebration deserves a touch of elegance, 
            joy, and unforgettable memories. Established with a passion for creating magical moments, 
            we specialize in premium balloon decorations and event styling.
          </p>
          
          <p className="welcome-description">
            Our team transforms ordinary spaces into extraordinary experiences for birthdays, parties, 
            anniversaries, baby showers, theme parties, and welcome baby celebrations. We use only 
            premium materials and create personalized designs that reflect your unique style and vision.
          </p>

          <div className="stats-container">
            {stats.map((stat, index) => (
              <div key={index} className={`stat-circle ${stat.lightBg ? 'stat-light-bg' : ''}`} style={{ '--stat-color': stat.color }}>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {showScrollTop && (
        <button className="scroll-to-top" onClick={scrollToTop} aria-label="Scroll to top">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 15l-6-6-6 6"/>
          </svg>
        </button>
      )}
    </section>
  );
};

export default WelcomeSection;
